import React from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { CommonCard } from "@components/Pages";
import { buildQS, url_reverse } from "@components/Utils";

function MerchantGame({ game_id }) {
    if (game_id === null) {
        return <span style={{ backgroundColor: "lightgreen" }}>many</span>;
    }
    return <Link to={url_reverse("games:page", { game_id })}>{game_id}</Link>;
}

export default function Month() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:finstatements:month"));

    if (!apiData) return;

    const buildReportUrl = (rep) => {
        if (!apiData.forms_data) {
            return "";
        }
        const params = buildQS({
            build_report: rep,
            "main-month": apiData.forms_data.main.data.month,
            "main-year": apiData.forms_data.main.data.year,
        });
        return url_reverse("api:finstatements:month") + "?" + params;
    };
    const buttons = (
        <>
            <Row className="m-1">
                <Col>
                    <a
                        className="btn btn-sm btn-success"
                        href={buildReportUrl("vkplay_month_excluded")}
                        target="_blank"
                    >
                        {t("Отчет VK Play [исключённое]")}
                    </a>
                </Col>
                <Col>
                    <a className="btn btn-sm btn-success" href={buildReportUrl("vkplay_month_grouped")} target="_blank">
                        {t("Отчет VK Play [сводный]")}
                    </a>
                </Col>
                <Col>
                    <a className="btn btn-sm btn-success" href={buildReportUrl("mygames_agent_act")} target="_blank">
                        {t("Отчет Агента (МАЙ.ГЕЙМЗ)")}
                    </a>
                </Col>
            </Row>
            <Row className="m-1">
                <Col>
                    <a className="btn btn-sm btn-success" href={buildReportUrl("vkplay_month_geo")} target="_blank">
                        {t("Отчет Geo")}
                    </a>
                </Col>
                <Col>
                    <a className="btn btn-sm btn-success" href={buildReportUrl("vkplay_wht_vat_rf")} target="_blank">
                        {t("Отчет WHT VAT RF")}
                    </a>
                </Col>
                <Col>
                    <a className="btn btn-sm btn-success" href={buildReportUrl("vkplay_phys_smz")} target="_blank">
                        {t("Отчет реализации физлиц и СМЗ")}
                    </a>
                </Col>
            </Row>
        </>
    );

    return (
        <>
            <CommonCard header={t("Ежемесячные отчеты")}>
                <RenderForm buttons={buttons} />
            </CommonCard>

            <Card className="mt-4">
                <Card.Header>{t("Мерчанты VK Play")}</Card.Header>
                <Card.Body>
                    <Table style={{ fontSize: "12px", width: "100%" }}>
                        <thead>
                            <tr>
                                <th>merchant_id</th>
                                <th>e-mail</th>
                                <th>{t("Игра")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {apiData.vkplay_merchants?.map((o) => {
                                return (
                                    <tr key={`vkplay_merchants${o.id}`}>
                                        <td>{o.id}</td>
                                        <td>{o.email}</td>
                                        <td>
                                            <MerchantGame game_id={o.game_id} />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
}
